import { Maybe } from "../../lib/misc/option";
import { NavMessage } from "../messages/NavMessage";
import { NavigationContext } from "./NavigationContext";
export class SingletonContext extends NavigationContext {
    constructor(map, p_layer, b_layer) {
        var _a, _b, _c;
        super(map);
        this.p_layer = p_layer;
        this.b_layer = b_layer;
        this.zoomed = false;
        this.name = 'singleton';
        this.max_zoom = (_c = (_b = (_a = map.getStrategy().config) === null || _a === void 0 ? void 0 : _a.Zoom) === null || _b === void 0 ? void 0 : _b.MaxZoom) !== null && _c !== void 0 ? _c : this.max_zoom;
        this.exit_contexts = ['set', 'group', 'toolbar', 'selection'];
    }
    async click_handler(coord, alt) {
        const existing_parcel = this.p_layer.data.get_feature_at_point_fast(coord);
        if (existing_parcel.isSome()) {
            const ex_id = this.p_layer.data.id_of(existing_parcel.unwrap());
            if (this.p_layer.clicked === ex_id)
                return;
        }
        ;
        if (this.p_layer.features.length === 1 || existing_parcel.isNone()) {
            this.p_layer.clear();
            this.b_layer.clear();
        }
        await this.p_layer.add_feature_at_point(coord, alt);
        const id = this.p_layer.clicked;
        if (id)
            new NavMessage({ command: 'NAVIGATE', strap: id, clicked: true, alt: alt }).send();
    }
    on_enter() {
        this.p_layer.use_base_style();
    }
    on_exit() { }
    zoom(force) {
        var _a, _b, _c;
        if (!this.p_layer.clicked) {
            this.view.fit(this.full_extent, { padding: [80, 80, 80, 80], duration: 50 });
            this.map.load_startup_visible_layers();
            return;
        }
        if (this.zoomed && !force) {
            this.map.load_startup_visible_layers();
            return;
        }
        const zoom_to_parcel_offset = (_c = (_b = (_a = this.map.getStrategy().config) === null || _a === void 0 ? void 0 : _a.Zoom) === null || _b === void 0 ? void 0 : _b.ZoomToParcelOffsetFromMaxZoom) !== null && _c !== void 0 ? _c : -2;
        const zoom = Math.min(this.max_zoom, this.max_zoom + zoom_to_parcel_offset);
        this.p_layer.get_feature_by_id(this.p_layer.clicked)
            .then(maybe_f => {
            maybe_f
                .flatmap(f => Maybe(f.getGeometry()))
                .map(g => g.getExtent())
                .map(e => [e, { padding: [80, 80, 80, 80], duration: 50, maxZoom: zoom }])
                .map(options => { this.view.fit(...options); this.zoomed = true; });
        });
        this.map.load_startup_visible_layers();
    }
    navigate(strap) {
        new NavMessage({ command: 'NAVIGATE', strap: strap, clicked: false, alt: false }).send();
    }
}
